import axios from 'axios'

// Create an isolated axios instance to avoid global pollution
// This prevents dependencies from affecting our requests via axios.defaults
const axiosInstance = axios.create({
  // Default config for this project
  withCredentials: false, // Explicitly set default - can be overridden per request
  timeout: 30000, // 30 seconds timeout
  headers: {
    'X-Requested-With': 'xmlhttprequest'
  }
})

addRequestInterceptor(axiosInstance)

const CancelToken = axios.CancelToken
const urlEncoded = (params = {}) => {
  if (typeof params === 'string') {
    return params
  }
  if (!params || typeof params !== 'object' || Array.isArray(params)) {
    return ''
  }
  return Object.keys(params).reduce((pre, cur) => {
    pre += pre
      ? `&${cur}=${encodeURIComponent(params[cur])}`
      : `${cur}=${encodeURIComponent(params[cur])}`
    return pre
  }, '')
}
let _cancel = {}

function addRequestInterceptor(axiosInstance) {
  axiosInstance.interceptors.request.use((config) => {
    if (config.method === 'post') {
      if (config.headers['Content-Type'] === 'application/x-www-form-urlencoded') {
        if (config.data && typeof config.data === 'object' && !Array.isArray(config.data)) {
          config.data = urlEncoded(config.data)
        }
      }
    }
    return config
  })
}

export function post(url, useRaw) {
  return function (data = {}) {
    return handleAjax(
      axiosInstance.post(url, data, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        cancelToken: new CancelToken(function executor(c) {
          _cancel[url] = c
        })
      }),
      useRaw
    )
  }
}

export function get(url, headers = {}, useRaw) {
  return function (params = {}) {
    return handleAjax(
      axiosInstance.get(url, {
        params,
        cancelToken: new CancelToken(function executor(c) {
          _cancel[url] = c
        }),
        headers
      }),
      useRaw
    )
  }
}

export function cancel(url) {
  return function () {
    _cancel[url] && _cancel[url]()
  }
}

function handleAjax(ajaxPromise, useRaw) {
  return ajaxPromise
    .then((res) => {
      // if res.header['content-type'] === 'text/html; charset=utf-8' reload page
      if ((((res || {}).headers || {})['content-type'] || '').includes('text/html')) {
        for (let url in _cancel) {
          cancel(url)
        }
        throw new Error('offline')
      }
      const serverData = res.data
      if (res.status === 200 && useRaw) {
        return res.data
      }
      if (serverData.errorCode === 0) {
        return serverData.result
      } else {
        return handleError(serverData)
      }
    })
    .catch((e) => {
      if (e.message === 'offline') {
        return Promise.reject(e)
      }
      return Promise.reject(axios.isCancel(e) ? e.message : e)
    })
}

function handleError(serverData) {
  const err = new Error(serverData.errorMessage)
  err.code = serverData.errorCode
  err.serverData = serverData
  return Promise.reject(err)
}

// Export the isolated axios instance for direct use
// Use this instead of importing axios directly to avoid global config pollution
export { axiosInstance }
